import React from 'react';

import PurchaseOrderShow from '@components/shared/purchaseOrders/PurchaseOrderShow';
import { useAuth } from '@contexts/admin/AuthContext';
import { useMerchant } from '@contexts/admin/MerchantContext';
import useCan from '@shared/permissions/useCan';
import purchaseOrderService from '@services/admin/purchaseOrderService';
import { useLoaderData } from 'react-router-dom';

export default function AdminPurchaseOrderShow() {
  const data = useLoaderData();
  const can = useCan();
  const { warehouses } = useMerchant();
  const { user } = useAuth();

  return (
    <PurchaseOrderShow
      purchaseOrder={data}
      service={purchaseOrderService}
      warehouses={warehouses}
      role="admin"
      canApprove={can('purchase_orders:approve')}
      currentUserId={user?.id}
    />
  );
}
